import { createPortal } from "react-dom";

/** Floating "Dashboard updated" confirmation. Rendered in a portal at
 *  the page's center-top so it's always visible regardless of scroll
 *  position, and doesn't shift page layout when it appears/disappears.
 *  Auto-dismiss is handled by the caller via `setToastMsg(null)`. */
export function ConfirmToast({ message }: { message: string }) {
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        top: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        padding: "10px 16px",
        borderRadius: 999,
        background: "rgba(34,197,94,0.96)",
        color: "#fff",
        fontSize: 13,
        fontWeight: 500,
        letterSpacing: 0.1,
        boxShadow:
          "0 8px 24px rgba(34,197,94,0.35), 0 1px 3px rgba(0,0,0,0.2)",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        animation: "toast-in 0.24s ease-out",
        pointerEvents: "none",
      }}
    >
      <span aria-hidden style={{ fontSize: 14, lineHeight: 1 }}>
        ✓
      </span>
      <span>{message}</span>
      <style>{`
        @keyframes toast-in {
          from { opacity: 0; transform: translate(-50%, -6px); }
          to   { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>,
    document.body
  );
}
